const Cursor = () => {
  return (
    <div className="bg-black animate-blink" style={{ height: "50%", width: "2px" }}>
    </div>
  )
}

const Letter = ({ index, value, result, active, animate, currentLetterIndex, readOnly, placeholder }) => {
  const activeLetter = active && !readOnly && index === currentLetterIndex;

  const getLetterClass = (value, result, active, animate) => {
    if (result) {
      return {
        R: `bg-success border-2 border-grey-mid text-white shadow-inner ${animate ? 'animate-flip-500' : ''}`,
        P: `bg-warning border-2 border-grey-mid text-white shadow-inner ${animate ? 'animate-flip-500' : ''}`,
        W: `bg-grey-mid border-2 border-grey-mid shadow-inner ${animate ? 'animate-flip-500' : ''}`,
      }[result]
    } else if(value) {
      return 'bg-white border-2 border-grey-mid shadow';
    } else if(active) {
      if (activeLetter) {
        return 'bg-white border-2 border-info shadow-inner';
      } else {
        return 'bg-white border-2 border-grey-mid shadow-inner';
      }
    } else {
      return 'border-2 border-grey-mid';
    }
  }

  const getLetterHeight = (value, result, active, animate) => getLetterClass(value, result, active, animate).indexOf('border-2') === -1 ? '100%' : 'calc(100% - 4px)';
  const getLetterTransitionDelay = index => `${150 + 300 * index}ms`
  const getLetterAnimationDelay = index => `${300 * index}ms`

  return (
    <div
      className={`${getLetterClass(value, result, active, animate)} transition ease-in-out duration-100 transform rounded-md relative`}
      style={{
        paddingBottom: getLetterHeight(value, result, active),
        transitionDelay: result && animate ? getLetterTransitionDelay(index) : 0,
        animationDelay: getLetterAnimationDelay(index)
      }}>
      <div
        className={`absolute inset-0 text-3xl sm:text-4xl uppercase flex justify-center items-center font-bold transition transform ${result && animate ? 'animate-flip-100' : ''}`}
        style={{ animationDelay: getLetterTransitionDelay(index) }}
      >
        {value || (activeLetter ? <Cursor /> : null)}
        {
          !value && (
            <span className="text-grey text-opacity-50">{placeholder}</span>
          )
        }
      </div>
    </div>
  )
}

export default Letter;
